"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/checkbox/index.ts
var checkbox_exports = {};
__export(checkbox_exports, {
  default: () => Checkbox_default
});
module.exports = __toCommonJS(checkbox_exports);
var import_index2 = require("./index.css");

// src/checkbox/Checkbox.tsx
var import_classnames2 = __toESM(require("classnames"));
var import_react2 = require("react");

// src/common/constants/index.ts
var componentSizeToBodyTextSizeMap = {
  l: "body-one",
  m: "body-two",
  s: "body-three",
  xs: "body-four"
};

// src/typography/index.ts
var import_index = require("./index.css");

// src/typography/Typography.tsx
var import_classnames = __toESM(require("classnames"));
var import_react = require("react");

// ../component-library-styles/typography.module.scss
var typography_module_default = {
  "heading-xxl": "typography-module__heading-xxl___t4Iml",
  "wrapper": "typography-module__wrapper___6sEjE",
  "heading-xl": "typography-module__heading-xl___wbMqr",
  "heading-lg": "typography-module__heading-lg___GUMI7",
  "heading-md": "typography-module__heading-md___I661h",
  "heading-sm": "typography-module__heading-sm___2Jm-k",
  "heading-xs": "typography-module__heading-xs___FJljd",
  "body-one": "typography-module__body-one___hKZXX",
  "body-two": "typography-module__body-two___Sa-Eb",
  "body-three": "typography-module__body-three___FIk3k",
  "body-four": "typography-module__body-four___vI1SQ",
  "overline-one": "typography-module__overline-one___rXzIm",
  "overline-two": "typography-module__overline-two___WG6bF",
  "overline-three": "typography-module__overline-three___UK5T-",
  "strong": "typography-module__strong___jtYq4",
  "em": "typography-module__em___2kNMg",
  "figcaption": "typography-module__figcaption___cHscw",
  "no-margin": "typography-module__no-margin___dyDRA"
};

// src/typography/Typography.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Typography = ({
  semanticTag,
  visualAppearance,
  children,
  className,
  style,
  id,
  noMargin = false,
  ...props
}) => {
  const Tag = semanticTag;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    Tag,
    {
      id,
      className: (0, import_classnames.default)(
        typography_module_default[visualAppearance],
        {
          [typography_module_default["no-margin"]]: noMargin,
          [typography_module_default.wrapper]: semanticTag === "div"
        },
        className
      ),
      style,
      ...props,
      children
    }
  );
};
var Typography_default = (0, import_react.memo)(Typography);

// src/checkbox/checkbox.module.scss
var checkbox_module_default = {
  "label": "checkbox-module__label___ooRXo",
  "label-xs": "checkbox-module__label-xs___e32xy",
  "label-s": "checkbox-module__label-s___hafkQ",
  "label-m": "checkbox-module__label-m___CBOxg",
  "label-l": "checkbox-module__label-l___7U6JB"
};

// src/checkbox/Checkbox.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var Checkbox = ({
  label,
  checked,
  onChange,
  name,
  value,
  disabled = false,
  indeterminate = false,
  size = "m",
  ...HTMLAttributes
}) => {
  const checkboxRef = (0, import_react2.useRef)(null);
  const bodyTextSize = componentSizeToBodyTextSizeMap[size];
  (0, import_react2.useEffect)(() => {
    if (checkboxRef == null ? void 0 : checkboxRef.current) {
      checkboxRef.current.indeterminate = indeterminate;
    }
  }, [checkboxRef, indeterminate]);
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)(
    "label",
    {
      className: (0, import_classnames2.default)(checkbox_module_default.label, checkbox_module_default[`label-${size}`]),
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
          "input",
          {
            type: "checkbox",
            ref: checkboxRef,
            name,
            value,
            checked,
            disabled,
            onChange,
            ...HTMLAttributes
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("i", { className: "fa-solid" }),
        label && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(Typography_default, { semanticTag: "span", visualAppearance: bodyTextSize, children: label })
      ]
    }
  );
};
var Checkbox_default = Checkbox;
//# sourceMappingURL=index.js.map